import React from 'react';
import RepVisitsUnlockPremiumView from '../RepVisitsUnlockPremiumView';
import contactsUnlockMessages from './contacts-unlock-messages';
import PageTitle from '../../components/PageTitle';

const unlockPremiumProps = {
  activeStyle: 'contacts',
  messages: contactsUnlockMessages,
};

const RepVisitsContactsUnlockPage = () => (
  <div>
    <PageTitle title="RepVisits" category="Intersect" />
    <RepVisitsUnlockPremiumView {...unlockPremiumProps} />
  </div>
);

export default RepVisitsContactsUnlockPage;
